export default __webpack_public_path__ + "static/media/bestehotel_thumb.bfb4521e.jpg";